globalThis.backoffice = globalThis.backoffice || {};

backoffice.ModalCustomerNeedDetectionLostConfirmation = (function(superClass)
{
    utils.extend(ModalCustomerNeedDetectionLostConfirmation, superClass);

    function ModalCustomerNeedDetectionLostConfirmation($html) {
        return ModalCustomerNeedDetectionLostConfirmation.__super__.constructor.apply(this, arguments);
    }

    $.extend(ModalCustomerNeedDetectionLostConfirmation.prototype, {
        init: function()
        {
            backoffice.initSelect2(this.$html.find('.select'));
            backoffice.initSelect2Search(this.$html.find('.select-search'));

            ModalCustomerNeedDetectionLostConfirmation.__super__.init.apply(this, arguments);
        }
    });

    return ModalCustomerNeedDetectionLostConfirmation;
})(backoffice.ModalMain);
